import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function BridgeSection() {
  return <section className="py-8 bg-white" data-id="element-33">
      <div className="container mx-auto px-4 max-w-2xl text-center" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-35">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1a1a2e] mb-4 font-montserrat leading-snug" data-id="element-36">
            La tecnología no va a desaparecer. Pero la forma en que la manejas
            en casa <span className="text-[#0ABFBC]" data-id="element-37">sí puede cambiar.</span>
          </h2>

          <div className="w-16 h-1 bg-[#F97316] mx-auto rounded-full mb-5" data-id="element-38" />

          <div className="space-y-3 text-gray-600 text-lg leading-relaxed" data-id="element-39">
            <p data-id="element-40">No se trata de prohibir. No se trata de gritar.</p>
            <p className="font-semibold text-[#1a1a2e]" data-id="element-41">
              Se trata de tener claridad.
            </p>
            <p data-id="element-42">
              Cuando hay estructura, hay calma. Cuando hay límites claros, hay
              respeto.
            </p>
            <p className="font-semibold text-[#1a1a2e]" data-id="element-43">
              Y todo empieza con un plan.
            </p>
          </div>

          {/* Family image */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mt-7 rounded-2xl overflow-hidden shadow-lg" data-id="element-44">
            <img src="https://cdn.magicpatterns.com/uploads/ruP9SdFesaWAYE7ZcripJh/madre_e_hiijo.png" alt="Madre e hijo conversando en casa" className="w-full h-64 md:h-80 object-cover" loading="lazy" decoding="async" width="1200" height="800" data-id="element-45" />
          </motion.div>

          {/* Caption below image */}
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.35
        }} className="mt-4 text-[#1a1a2e] font-semibold text-lg md:text-xl" data-id="element-46">
            Pequeños cambios estratégicos pueden transformar la convivencia
            diaria.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}